import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { lastCompany } from "./companies/useMe";
// fonts are served with the app (no third-party font requests)
import "@fontsource-variable/instrument-sans";
import "@fontsource-variable/newsreader/opsz.css";
import "@fontsource-variable/jetbrains-mono";
import "./styles.css";
import { reportErrors } from "./lib/errors";

reportErrors();
// the installable app (public/sw.js); not while developing
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => { void navigator.serviceWorker.register("/sw.js").catch(() => undefined); });
}

// opened from the Altekore account for one company (?company=<id>): work in that company, and drop it from the address.
// Someone who isn't in that company gets "Choose a company" from the shell, as with any company they've left.
{
  const u = new URL(location.href); const c = u.searchParams.get("company");
  if (c && /^[0-9a-f-]{36}$/i.test(c)) { lastCompany.set(c); u.searchParams.delete("company"); history.replaceState(null, "", u.pathname + u.search + u.hash); }
}
createRoot(document.getElementById("root")!).render(<StrictMode><App /></StrictMode>);
